import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
    return (
        <>
            <Seo
                title="Page not found"
                description="The page you were looking for doesn’t exist. Try the tool library or the blog."
            />
            <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
                <p className="text-sm text-slate-500">404</p>
                <h1 className="mt-2 text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900">
                    We couldn’t find that page.
                </h1>
                <p className="mt-4 text-slate-600">
                    The link may be broken, or the page may have moved. Try one of the
                    options below.
                </p>
                <div className="mt-8 flex items-center justify-center gap-3">
                    <Button asChild className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--link-hover))] text-white">
                        <Link to="/tools">Browse tools</Link>
                    </Button>
                    <Button asChild variant="secondary">
                        <Link to="/blog">Read the blog</Link>
                    </Button>
                </div>
            </section>
        </>
    );
}
